import { useContext } from 'react'
import { batch, useDispatch, useSelector } from 'react-redux'
import Loading from 'components/loading/Loading'
import NoneAnchor from 'components/NoneAnchor'
import { setFilters } from 'features/dashboard/filter/dashboardFilterSlice'
import { paramToFilter } from 'features/dashboard/utils/dashboardUtils'
import { FilterContext } from 'features/dashboard/filter/FilterContext'
import { campaignTableActions } from 'features/dashboard/table/campaign/campaignTableSlice'
import { adGroupTableActions } from 'features/dashboard/table/adGroup/adGroupTableSlice'
import { keywordTableActions } from 'features/dashboard/table/keyword/keywordTableSlice'
import { creativeTableActions } from 'features/dashboard/table/creative/creativeTableSlice'

const SavedFilters = () => {
  const dispatch = useDispatch()
  const { setMenuVisible, showDeleteSavedFilterConfirm } =
    useContext(FilterContext)
  const { savedFilters, isLoading } = useSelector(
    state => state.dashboard.filter
  )
  return (
    <>
      <ul className="list_lyadsearch">
        {isLoading ? (
          <Loading />
        ) : savedFilters.length === 0 ? (
          <li>
            <span className="link_searchfilter">저장한 검색 조건 없음</span>
          </li>
        ) : (
          savedFilters.map(({ id, name, filters }) => (
            <li key={id}>
              <NoneAnchor
                className="btn_addel"
                onClick={() => {
                  showDeleteSavedFilterConfirm({ id, name })
                }}>
                <span className="ico_comm">삭제</span>
              </NoneAnchor>
              <NoneAnchor
                className="link_searchfilter"
                onClick={() => {
                  setMenuVisible(false)
                  window.scrollTo({ top: 0 })
                  const parsed = JSON.parse(filters)
                  batch(() => {
                    dispatch(setFilters(paramToFilter(parsed)))
                    dispatch(campaignTableActions.setPage(0))
                    dispatch(adGroupTableActions.setPage(0))
                    dispatch(keywordTableActions.setPage(0))
                    dispatch(creativeTableActions.setPage(0))
                  })
                }}>
                {name}
              </NoneAnchor>
            </li>
          ))
        )}
      </ul>
    </>
  )
}
export default SavedFilters
